import React, { PureComponent, ReactNode } from "react";
import { ICON_SETTINGS } from "../../../constants/iconConstants";
import IconButton from "../../theme_reuse/IconButton";
import { AppContextType, MenuName } from "../../../AppContext";

interface Props {
  menuName: MenuName;
}
interface State {}

export default class OpenSettingsMenuButton extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  showMenu = () => {
    this.context.dispatch({ type: "ShowMenu", payload: this.props.menuName });
  };

  render(): ReactNode {
    return <IconButton mini title="Settings Menu" icon={ICON_SETTINGS} onClick={this.showMenu} />;
  }
}

OpenSettingsMenuButton.contextType = AppContextType;
